module.exports = __webpack_public_path__ + "media/ringtones1.2e0d92d9.mp3";